import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import ApplicationFormPage from "./pages/ApplicationFormPage";
import BayilikPage from "./pages/BayilikPage";
import { lazy, Suspense } from "react";

// Yönetim paneli ayrı parça: tanıtım sayfasına gelen ziyaretçi panelin kodunu indirmesin.
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminLayout = lazy(() => import("./layouts/AdminLayout"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const AdminCouriers = lazy(() => import("./pages/AdminCouriers"));
const AdminRestaurants = lazy(() => import("./pages/AdminRestaurants"));
const AdminCompanies = lazy(() => import("./pages/AdminCompanies"));
const AdminIntegrations = lazy(() => import("./pages/AdminIntegrations"));
const AdminReferences = lazy(() => import("./pages/AdminReferences"));
const AdminSettings = lazy(() => import("./pages/AdminSettings"));
const AdminUsers = lazy(() => import("./pages/AdminUsers"));

const Yukleniyor = () => <div className="min-h-screen bg-background" />;

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<Yukleniyor />}>
          <Routes>
            {/* Landing Page */}
            <Route path="/" element={<LandingPage />} />

            {/* Bayilik reklam landing'i (kurye şirketi / franchise) */}
            <Route path="/bayilik" element={<BayilikPage />} />

            {/* Direct Application Form Pages (SEO friendly) */}
            <Route path="/kurye-basvuru-formu" element={<ApplicationFormPage formSlug="kurye-basvuru-formu" />} />
            <Route path="/restoran-basvuru-formu" element={<ApplicationFormPage formSlug="restoran-basvuru-formu" />} />
            <Route path="/sirket-basvuru-formu" element={<ApplicationFormPage formSlug="sirket-basvuru-formu" />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="couriers" element={<AdminCouriers />} />
              <Route path="restaurants" element={<AdminRestaurants />} />
              <Route path="companies" element={<AdminCompanies />} />
              <Route path="integrations" element={<AdminIntegrations />} />
              <Route path="references" element={<AdminReferences />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="users" element={<AdminUsers />} />
            </Route>
          </Routes>
          </Suspense>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
